export const advantageCartData = [
  {
    id: 1,
    title: "Time Efficiency",
    description:
      "With Unlock Your Potential, Instantly!, you no longer need to spend countless hours reading through entire books. Our platform offers you the top key points from self-help books, allowing you to quickly absorb valuable knowledge and apply it to your life immediately.",
  },
  {
    id: 2,
    title: "Personaled Growth",
    description:
      "Our platform caters to your unique needs and goals, enabling you to select and focus on the insights that are most relevant to your personal and professional development. This tailored approach ensures more effective and meaningful self-improvement experiences.",
  },
  {
    id: 3,
    title: "Access to expertise",
    description:
      "SelfhelpSnaps, Instantly! gives you the opportunity to learn from the best minds in self-help, personal growth, and professional development. By consolidating their wisdom into concise, actionable points, our platform empowers you to rapidly incorporate expert advice into your daily life, ultimately leading to greater success and fulfillment.",
  },
];
